<template>
  <div
    v-if="isLoginMode && isAuthorizedMode"
    class="vimeo-wrapper"
    v-html="movieHtmlCode"
  />
  <div v-else>
    <div class="vimeo-mask">
      <img
        :src="thumbnailUrl"
        class="vimeo-wrapper"
      >
      <div class="vimeo-mask-contents text-center w-100 row mx-auto">
        <div class="col-12">
          <p class="text-white font-weight-bold mb-5">
            {{ (isLoginMode) ? t('msg.authority_is_required_to_play_the_video') : t("msg.registration_is_required_to_play_the_video") }}
          </p>
        </div>
        <div class="col-12">
          <div v-if="!isLoginMode">
            <div>
              <a
                :href="loginPath"
                class="btn btn-default btn-lg mx-auto mb-3 d-inline-block"
              >
                {{ t("sign_in") }}
              </a>
            </div>
            <a
              :href="newUsePath"
              class="btn btn-default btn-lg d-inline-block"
            >
              {{ t("contact_to_join") }}
            </a>
          </div>
          <div v-else>
            <p class="text-white font-weight-bold">
              {{ t('contact_to_new_use') }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Player from "@vimeo/player";
import axios from "axios";
import { i18n } from "../mixins/i18n";

export default {
  mixins: [i18n],
  props: {
    isLoginMode: {
      type: Boolean,
      default: false
    },
    isAuthorizedMode: {
      type: Boolean,
      default: false
    },
    movieHtmlCode: {
      type: String,
      default: ""
    },
    ajaxPath: {
      type: String,
      default: ""
    },
    loginPath: {
      type: String,
      default: ""
    },
    newUsePath: {
      type: String,
      default: ""
    },
    movieId: {
      type: Number,
      default: 0
    },
    thumbnailUrl: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      isPosted: false
    };
  },
  mounted() {
    if (!this.isLoginMode || !this.isAuthorizedMode) {
      return;
    }

    const iframe = document.querySelector("iframe");
    const player = new Player(iframe);

    axios.defaults.headers["X-CSRF-TOKEN"] = document.getElementsByName("csrf-token")[0].content;
    axios.defaults.headers.X_REQUESTED_WITH = "XMLHttpRequest";

    player.on("play", () => {
      if (this.isPosted === false) {
        this.isPosted = true;
        axios.post(this.ajaxPath, { movie_id: this.movieId })
          .then(response => {

            // セッションが切れた場合、ログイン画面に遷移
            if (response.data.status === 401) {
              window.location.href = this.loginPath;
            }
          });
      }
    });
  }
};
</script>

<style lang="scss" scoped>
.vimeo-wrapper{
  position: relative;
  width: 900px;
  @media (max-width:900px) {
    width: 100%;
  }
}

.vimeo-wrapper:before {
    content:"";
    display: block;
    padding-top: 56.25%; /* 高さと幅の比を16:9に固定。9/16*100=56.25 */
}

.vimeo-wrapper{
  /deep/ iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}

.vimeo-mask{
  position: relative;
}

.vimeo-mask:before{
  position: absolute;
  display: block;
  content: "";
  background-color: #282828;
  opacity: .8;
  width: 100%;
  height: 100%;
}

.vimeo-mask img{
  z-index: -1;
  display: block;
}

.vimeo-mask-contents {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%,-50%);
  -webkit-transform: translate(-50%,-50%);
  transform: translate(-50%,-50%);
}
</style>
